import { render, staticRenderFns } from "./GPUs.vue?vue&type=template&id=8d1a6e3c&"
import script from "./GPUs.vue?vue&type=script&lang=js&"
export * from "./GPUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports